import { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import quarkusApi from '../api/quarkusApi';

// `enabled` permite adiar a busca em telas que só precisam da lista em certas condições,
// como o modal de tratamento, que só usa convênios quando a clínica trabalha com eles.
export function useCovenantCatalog(enabled = true) {
  const navigate = useNavigate();

  const [covenants, setCovenants] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Devolve a promise (resolvida com a lista) para quem precisa agir logo após o refetch,
  // como um cadastro rápido de convênio dentro de outro formulário.
  const fetchCovenants = useCallback(() => {
    if (!enabled) return Promise.resolve([]);

    setLoading(true);
    return quarkusApi
      .get('/covenant-catalog', { headers: { Authorization: sessionStorage.getItem('token') } })
      .then((returnFromApi) => {
        setCovenants(returnFromApi.data);
        return returnFromApi.data;
      })
      .catch((returnFromApi) => {
        setError(returnFromApi.response?.data);
        console.error('ops! ocorreu um erro' + returnFromApi);
        if (returnFromApi.status === 401) {
          navigate('/expired-session');
        }
      })
      .finally(() => setLoading(false));
  }, [enabled, navigate]);

  useEffect(() => {
    fetchCovenants();
  }, [fetchCovenants]);

  return { covenants, isLoading, error, refetch: fetchCovenants };
}
